//
// Helper de auditoria de cadastros.
//
// Le do localStorage (mesma fonte do router guard / Header) e devolve
// um objeto pra mesclar no payload de save:
//
//   - novo cadastro (INSERT): codigoUsuarioCriacao / nomeUsuarioCriacao / dataCriacao
//   - edicao (UPDATE):        codigoUsuarioAlteracao / nomeUsuarioAlteracao / dataAlteracao
//
// Backend trata todos os campos como nullable - se algum vier vazio (ex.:
// localStorage corrompido), grava NULL silenciosamente sem erro.
//
// Uso em CadastroVeiculo / CadastroMotorista / CiotCadastro:
//
//   import { auditoriaPayload } from '../utils/auditoria'
//   ...
//   const dados = { ...formAtual, ...auditoriaPayload(this.modoEdicao) }
//

/**
 * Devolve o "agora" como string ISO LOCAL (sem o Z de UTC).
 *
 * Por que NAO usar new Date().toISOString():
 *   toISOString sempre converte pra UTC e anexa 'Z'. O backend grava o
 *   campo como LocalDateTime (sem fuso) e ignora o Z. Resultado: 22:50
 *   BRT vira "2026-06-15T01:50:00Z", o backend grava "01:50" sem fuso, e
 *   o front le de volta "01:50" interpretado como local. Os registros
 *   apareciam com +3h no Log de Cadastros.
 *
 * Esta funcao constroi a string a partir dos getters LOCAIS do Date
 * ("2026-06-14T22:50:30" - sem Z). Backend grava 22:50, front le 22:50.
 *
 * Precisao em segundos basta - ms nao adicionam valor no log.
 */
function agoraIsoLocal() {
  const d = new Date()
  const pad = (n) => String(n).padStart(2, '0')
  return (
    d.getFullYear() + '-' +
    pad(d.getMonth() + 1) + '-' +
    pad(d.getDate()) + 'T' +
    pad(d.getHours()) + ':' +
    pad(d.getMinutes()) + ':' +
    pad(d.getSeconds())
  )
}

/**
 * Le id+nome do usuario do localStorage com fallback seguro.
 */
function getUsuarioAtual() {
  const id = Number(localStorage.getItem('id')
                 || localStorage.getItem('idUsuario')
                 || 0) || null
  let nome = null
  try {
    const rawUserData = localStorage.getItem('userData')
    if (rawUserData) {
      const userData = JSON.parse(rawUserData)
      nome = userData && (userData.username || userData.description) || null
    }
  } catch (e) {
    // userData corrompido - segue sem
  }
  if (!nome) {
    nome = localStorage.getItem('userLogin') || null
  }
  return { id, nome }
}

/**
 * Monta o objeto de auditoria pro payload de save.
 *
 * @param {Boolean} ehEdicao  true = UPDATE (preenche campos de alteracao),
 *                            false/undefined = INSERT (preenche campos de criacao)
 * @returns {Object}          objeto pronto pra spreadar no payload
 */
export function auditoriaPayload(ehEdicao) {
  const { id, nome } = getUsuarioAtual()
  // Horario LOCAL sem timezone marker - backend grava como LocalDateTime
  // (sem fuso). Se usassemos toISOString (UTC com 'Z'), o backend gravaria
  // +3h em BRT e o log apareceria com data deslocada.
  const agora = agoraIsoLocal()
  if (ehEdicao) {
    return {
      codigoUsuarioAlteracao: id,
      nomeUsuarioAlteracao: nome,
      dataAlteracao: agora
    }
  }
  return {
    codigoUsuarioCriacao: id,
    nomeUsuarioCriacao: nome,
    dataCriacao: agora
  }
}
